module.exports = __webpack_public_path__ + "static/img/bsWeiTu3.2fbe980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bussinessServesImg/bsWeiTu3.png
// module id = Z9uo
// module chunks = 1